import { Component, OnInit } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-password',
  templateUrl: './formly-password.component.html',
  styleUrls: [],
})
export class FormlyPasswordComponent extends FieldType implements OnInit {
  styleBugFixClass = 'p-password p-component p-inputwrapper p-input-icon-right' //This is needed to fix a known bug with this component in PrimeNg 13
  styleClass = ''
  mediumRegexPrimeDefault =
    '^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,}).'
  strongRegexPrimeDefault = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})'

  ngOnInit() {
    this.styleClass = this.getStyleClass(this.props)
  }
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Home' || event.key === 'End') {
      event.stopPropagation()
    }
  }

  getStyleClass(props: any): string {
    let styleClass: string = props.styleClass
      ? props.styleClass + ' ' + this.styleBugFixClass
      : this.styleBugFixClass
    styleClass += props.toggleMask ? '' : ' basin-pr-0'
    return styleClass
  }
}
